<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Standard Rate</h5>
  </div>
  <div id="mainContent" class="container">
    <div class="row pt-3">
      <div class="col-md-2" style="padding-left:30px;">
        <label>Branch :</label>
        <select class="form-control form-control-xs" [id]="'branch'" [name]="'branch'" type="text"
          class="form-control form-control-xs" [(ngModel)]="selectedBranch" (change)="loadStandardRates()"
          matTooltip="select branch" matTooltipPosition="above">
          <option>Select</option>
          <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
        </select>
      </div>
      <div class="col-md-2 offset-md-1">
        <label class="mb-0">Financial Year :</label>
        <div class="form-group mb-0">
          <select class="form-control form-control-xs" [id]="'financialYear'" [name]="'financialYear'" type="text"
            [(ngModel)]="selectYear" matTooltip="select Fy year" matTooltipPosition="above"
            (change)="loadStandardRates()">
            <option>Select</option>
            <option *ngFor="let financialYear of financialYearList " [ngValue]="financialYear">{{ financialYear.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 offset-md-4" style="padding-top: 15px;">
        <button id="addStandardBtn" name="addStandardBtn" mat-raised-button class="btn-theme" style="float:right"
          matTooltip="Click to add" matTooltipPosition="left" (click)="openModal(modalContent,'add')">
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Standard Rate
        </button>
      </div>
    </div>


    <div class="pt-2 pb-2">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Financial Year</th>
              <th scope="col">Branch</th>
              <th scope="col">Role</th>
              <th scope="col">Service Vertical</th>
              <th scope="col">Rate</th>
              <th scope="col" *ngIf="!disableButtons">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let modalFormObj of modalFormObjList; index as i" id="standard_{{i}}">
              <td scope="row">{{i+1}}</td>
              <td>{{modalFormObj.financialYear.name}}</td>
              <td>{{modalFormObj.branch.name}}</td>
              <td>{{modalFormObj.role.name}}</td>
              <td>{{modalFormObj.serviceVertical == null ? '' : modalFormObj.serviceVertical.name}}</td>
              <td>{{modalFormObj.rate}}</td>
              <td *ngIf="!disableButtons">
                <button id="editStandardBtn_{{i}}" name="editStandardBtn_{{i}}" class="btn btn-sm btn-outline-theme"
                  (click)="onEditClick(modalContent,modalFormObj)" matTooltip="Click to edit"
                  matTooltipPosition="above">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button> &nbsp;&nbsp;
                <button id="deleteStandardBtn_{{i}}" name="deleteStandardBtn_{{i}}"
                  class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
                  matTooltip="Click to delete" matTooltipPosition="above">
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Standard Rate</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="row">
        <label class="col-sm-6">Financial Year :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="financialYear" name="financialYear" type="text"
            class="form-control form-control-xs" formControlName="financialYear"
            [class.is-invalid]="formErrors.financialYear && formSubmitted" matTooltip="{{formErrors.financialYear}}"
            matTooltipPosition="above">
            <option [value]="null">Select</option>
            <option *ngFor="let financialYear of financialYearList" [ngValue]="financialYear">{{ financialYear.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-6">Branch :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="branch" name="branch" type="text"
            class="form-control form-control-xs" formControlName="branch"
            [class.is-invalid]="formErrors.branch && formSubmitted" matTooltip="{{formErrors.branch}}"
            matTooltipPosition="above">
            <option [value]="null">Select</option>
            <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-6">Role :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="role" name="role" type="text"
            formControlName="role" [compareWith]="compareById"
            [class.is-invalid]="formErrors.role && formSubmitted" matTooltip="{{formErrors.role}}"
            matTooltipPosition="above">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let role of roleList" [ngValue]="role">{{ role.name }}</option>
          </select>
        </div>
      </div>
       <div class="row">
        <label class="col-sm-6">Service Vertical :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="serviceVertical" name="serviceVertical" type="text"
          formControlName="serviceVertical" [compareWith]="compareById"
          [class.is-invalid]="formErrors.serviceVertical && formSubmitted" matTooltip="{{formErrors.serviceVertical}}" matTooltipPosition="above">
          <option [ngValue]="null">Select</option>
            <option *ngFor="let serviceVertical of serviceVerticalList" [ngValue]="serviceVertical">{{ serviceVertical.name }}</option>
          </select>
        </div>
        </div>
      <div class="row">
        <label class="col-sm-6">Standard Rate Per Day:</label>
        <div class="col-sm-6">
          <input id="rate" name="rate" type="number" class="form-control form-control-xs" formControlName="rate"
            [class.is-invalid]="formErrors.rate && formSubmitted" matTooltip="{{formErrors.rate}}"
            matTooltipPosition="above" matTooltipClass="warn-tooltip" (input)="limitDecimal($event)">

          <!-- <div class="validation-error" *ngIf="modalForm.get('rate').hasError('pattern')
          && modalForm.get('rate').touched"
        >
          Invalid input.
        </div> -->
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button id="closeStandardBtn" name="closeStandardBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
      </div>
      <div class="col-sm-3">
        <button id="saveStandardBtn" name="saveStandardBtn" type="button" *ngIf="modalStatus=='add'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
        <button id="updateStandardBtn" name="updateStandardBtn" type="button" *ngIf="modalStatus=='edit'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
      </div>
    </div>
  </div>
</ng-template>